import { render, staticRenderFns } from "./StoryItemMedia.vue?vue&type=template&id=0f720c60&scoped=true&"
import script from "./StoryItemMedia.vue?vue&type=script&lang=ts&"
export * from "./StoryItemMedia.vue?vue&type=script&lang=ts&"
import style0 from "./StoryItemMedia.vue?vue&type=style&index=0&id=0f720c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f720c60",
  null
  
)

export default component.exports